import React from "react";
import { CardFooter, PrimaryButton, StickyFooterButtons } from "best-common-react";
import { inject, observer } from "mobx-react";

function InvestigationsFooter(props) {
  const { investigationsStore } = props.rootStore;

  return (
    <CardFooter>
      <StickyFooterButtons>
        <PrimaryButton
          right
          disabled={!investigationsStore.isValidSearch}
          onClick={() => {
            investigationsStore.investigationReport();
          }}
        >
          Export to Excel
        </PrimaryButton>
      </StickyFooterButtons>
    </CardFooter>
  );
}

export default inject("rootStore")(observer(InvestigationsFooter));
